import { AlertType } from "../../../interfaces/enums";
import { ReloadItemParams } from "../types";
import uploadFile from "./uploadFile";

const reloadItem = async (props: ReloadItemParams) => {
  const { sku, fetchedProducts, setFetchedProducts, setModalToShow, setToast, setIsLoading } =
    props;

  const product = fetchedProducts.find((product) => product.csvLineArray[0] === sku);

  if (!product) {
    setToast({
      type: AlertType.Error,
      message: "Product not found",
    });
    return;
  }
  setModalToShow("progressBar");
  const { newFetchedProducts } = await uploadFile({
    csvEachLineArray: [product.csvLineArray],
    setIsLoading,
    setToast,
  });

  setModalToShow(null);
  const oldFetchedProducts = fetchedProducts.filter((product) => product.csvLineArray[0] !== sku);

  setFetchedProducts([...oldFetchedProducts, ...newFetchedProducts]);
};

export default reloadItem;
